import Card from 'components/Layout/Card'
import Loader from 'components/Layout/Loader'
import UserProfileDetailsCard from 'components/Layout/UserProfileDetailsCard'
import EducationSection from 'pages/Common/RequestRaisedAndReceived/MembershipTypeChange/DetailsComponents/EducationSection'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { fetchAuthorDetails } from 'store/slices'
import { getDataFromLocalStorage } from 'utils/helpers'

const AuthorDetailsView = () => {
  const dispatch = useDispatch()
  const [authorData, setAuthorData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();
  const { authorId } = params;
  const navigate = useNavigate()

  const getAuthorDetails = async () => {
    setIsLoading(true);
    const response = await dispatch(fetchAuthorDetails(authorId));
    if (response?.data) {
      setAuthorData(response?.data);
    }
    setIsLoading(false);
  };


  useEffect(() => {
    if (['0', '1', '6', '7'].includes(getDataFromLocalStorage('user_type'))) {
      getAuthorDetails()
    } else {
      navigate('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorId]);

  const { user_details, educational_details } = authorData
  return (
    <div className="row g-3">

      {isLoading ? <Card className="cp-24">
        <Loader size="md" />
      </Card> :
        <>
          <div className="col-12 col-sm-12 col-md-5 col-lg-4">
            <UserProfileDetailsCard user_details={user_details} navigation />
          </div>

          <div className='col-12 col-sm-12 col-md-7 col-lg-8'>
            <Card className="cp-24 cmb-17 h-100">
              <div className="text-14-500-18 color-text-blue cmb-18">
                Education Details :
              </div>

              {!(
                educational_details?.ug_course ||
                educational_details?.pg_course ||
                educational_details?.phd_course ||
                educational_details?.disciplines ||
                educational_details?.languages
              ) ? (
                <div className="row">
                  <div className="col-12 text-center text-14-400-18 color-light-grey cpt-20 cpb-20">
                    No educational data found.
                  </div>
                </div>
              ) : (
                <div className="row">
                  {/* UG Section */}
                  <EducationSection
                    labelPrefix="UG"
                    details={{
                      course: educational_details?.ug_course,
                      department: educational_details?.ug_department,
                      university: educational_details?.ug_university,
                      institution: educational_details?.ug_institution,
                      year_of_completion: educational_details?.ug_year_of_completion,
                    }}
                  />

                  {/* PG Section */}
                  <EducationSection
                    labelPrefix="PG"
                    details={{
                      course: educational_details?.pg_course,
                      department: educational_details?.pg_department,
                      university: educational_details?.pg_university,
                      institution: educational_details?.pg_institution,
                      year_of_completion: educational_details?.pg_year_of_completion,
                    }}
                  />

                  {/* Ph.D Section */}
                  <EducationSection
                    labelPrefix="Ph.D"
                    details={{
                      course: educational_details?.phd_course,
                      department: educational_details?.phd_department,
                      university: educational_details?.phd_university,
                      institution: educational_details?.phd_institution,
                      year_of_completion: educational_details?.phd_year_of_completion,
                    }}
                  />

                  {/* Disciplines */}
                  {educational_details?.disciplines && (
                    <>
                      <div className="text-14-500-18 color-text-blue cmt-15">
                        Disciplines :
                      </div>
                      <div className="d-flex flex-wrap gap-2 cmt-16">
                        {educational_details?.disciplines
                          .split(",")
                          .map((disc, index) => (
                            <div
                              key={index}
                              className="cps-12 cpe-12 cpb-6 cpt-6 text-14-400-18 color-black-olive bg-F3F4F8 br-5"
                            >
                              {disc.trim()}
                            </div>
                          ))}
                      </div>
                    </>
                  )}

                  {/* Languages */}
                  {educational_details?.languages && (
                    <>
                      <div className="text-14-500-18 color-text-blue cmt-19">
                        Languages :
                      </div>
                      <div className="d-flex flex-wrap gap-2 cmt-16">
                        {educational_details?.languages
                          .split(",")
                          .map((lang, index) => (
                            <div
                              key={index}
                              className="cps-12 cpe-12 cpb-6 cpt-6 text-14-400-18 color-black-olive bg-F3F4F8 br-5"
                            >
                              {lang.trim()}
                            </div>
                          ))}
                      </div>
                    </>
                  )}
                </div>
              )}
            </Card>
          </div>

        </>}
    </div>
  )
}

export default AuthorDetailsView
